import Component from './carousel-controller';

export default Component;